import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type AnnouncementModel from 'garaje/models/announcement';
import type AnnouncementTemplateModel from 'garaje/models/announcement-template';

export default class AnnouncementResponseOptionModel extends Model {
  @attr('string') declare category: string;
  @attr('date') declare createdAt: Date;
  @attr('string') declare label: string;
  @attr('number') declare order: number;
  @attr('string') declare referenceId: string;
  @attr('string') declare referenceType: string;
  @attr('date') declare updatedAt: Date;

  // Polymorphic relationships
  @belongsTo('announcement', {
    async: true,
    inverse: 'announcementResponseOptions',
    polymorphic: false,
  })
  declare announcement: AsyncBelongsTo<AnnouncementModel>;

  @belongsTo('announcement-template', {
    async: true,
    inverse: 'announcementResponseOptions',
    polymorphic: false,
  })
  declare announcementTemplate: AsyncBelongsTo<AnnouncementTemplateModel>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'announcement-response-option': AnnouncementResponseOptionModel;
  }
}
